export default "__VITE_ASSET__CatmD93g__"